import { CONTACT } from "../data/content";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float-button"
    href={`https://wa.me/91${CONTACT.phone}?text=${encodeURIComponent(
      "Hi, I'm interested in Aaroh Farms farmhouse plots. Please share details."
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-28 sm:bottom-32 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] grid place-items-center shadow-xl shadow-[#25D366]/30 transition-all duration-300 hover:scale-110 hover:shadow-2xl animate-[pulse_3s_ease-in-out_infinite]"
  >
    <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white">
      <path d="M16 2C8.28 2 2 8.28 2 16c0 2.47.64 4.87 1.86 7L2 30l7.2-1.82A13.93 13.93 0 0 0 16 30c7.72 0 14-6.28 14-14S23.72 2 16 2zm0 25.6c-2.2 0-4.36-.6-6.24-1.72l-.45-.27-4.25 1.07 1.1-4.14-.29-.46A11.5 11.5 0 0 1 4.4 16c0-6.4 5.2-11.6 11.6-11.6S27.6 9.6 27.6 16 22.4 27.6 16 27.6zm6.36-8.7c-.35-.17-2.06-1.02-2.38-1.13-.32-.12-.55-.18-.79.17-.23.35-.9 1.13-1.1 1.37-.2.23-.41.26-.76.09a9.45 9.45 0 0 1-2.8-1.73 10.5 10.5 0 0 1-1.94-2.4c-.2-.35-.02-.54.15-.71.16-.16.35-.41.53-.61.17-.2.23-.35.35-.58.11-.23.06-.44-.03-.61-.09-.17-.79-1.9-1.08-2.6-.28-.68-.57-.59-.79-.6h-.67c-.23 0-.61.09-.93.44-.32.35-1.22 1.2-1.22 2.92s1.25 3.4 1.43 3.63c.17.23 2.47 3.77 5.98 5.29.84.36 1.5.58 2.01.74.84.27 1.6.23 2.21.14.67-.1 2.06-.84 2.35-1.66.29-.82.29-1.52.2-1.66-.08-.15-.31-.23-.66-.4z" />
    </svg>
  </a>
);
